import {Component, EventEmitter, Input, OnInit, Output} from '@angular/core';
import {Seguro} from '../../../_models/seguro';
import {AbstractControl, FormArray, FormBuilder, FormControl, FormGroup, ValidatorFn} from '@angular/forms';
import {ListaItem} from '../../../_models/lista-item';
import {NavService} from '../../../_services/_nav.service';
import {ListaService} from '../../../_services/lista.service';
import {SegurosbienesService} from '../../../_services/segurosbienes.service';
import {SegurosBienes} from '../../../_models/seguros-bienes';
import {forkJoin, of} from 'rxjs';
import {ParametrosSegurosBienes} from '../../../_enums/enum';
import {SegurosBienesTipoConstruccionService} from '../../../_services/seguros-bienes-tipo-construccion.service';
import {SegurosBienesTipoConstruccion} from '../../../_models/seguros-bienes-tipo-construccion';

@Component({
  selector: 'app-seguros-bienes',
  templateUrl: './seguros-bienes.component.html',
  styleUrl: './seguros-bienes.component.css'
})
export class SegurosBienesComponent implements OnInit {

  @Input() seguro: Seguro;
  @Output() cancelar = new EventEmitter<any>();
  submitted = false;
  listaTipoConstruccion: ListaItem[] = [];
  listaBinesAsegurablesTodos: ListaItem[] = [];
  segurosBienes: SegurosBienes[] = [];
  segurosBienesTipoConstrucciones: SegurosBienesTipoConstruccion[] = [];
  parametrosTipoLista: string[] = [ParametrosSegurosBienes.BIETIC];
  loading: boolean = true;
  formulario!: FormGroup;
  guardando: boolean = false;


  constructor(private navServicio: NavService,
              private fb: FormBuilder,
              private lisServicio: ListaService,
              private segurosbienesService: SegurosbienesService,
              private segurosBienesTipoConstruccionService: SegurosBienesTipoConstruccionService) {

  }

  ngOnInit(): void {
    this.initForm();
    this.cargarDatos();
  }


  private initForm(): void {
    this.formulario = this.fb.group({
      bienesParametros: this.fb.array([])
    });
  }

  get bienesArray(): FormArray {
    return this.formulario.get('bienesParametros') as FormArray;
  }

  private cargarDatos(): void {

    this.segurosbienesService.listadoPorIdSeguro(this.seguro.idSeguro).subscribe(segurosBienes => {

      const seguroBienBietic = segurosBienes.find(
        b => b.codigoBienAsegurable === ParametrosSegurosBienes.BIETIC
      );

      forkJoin({
        listasBienesAsegurables: this.lisServicio.getMasterDetails('ListasBienesAsegurables'),
        listaTiposConstruccion:  this.lisServicio.getMasterDetails('ListasTiposConstruccionViviendas'),
        tipoConstrucciones:      seguroBienBietic?.idSeguroBien
          ? this.segurosBienesTipoConstruccionService.listadoPorIdSeguroBien(seguroBienBietic.idSeguroBien)
          : of([])
      }).subscribe(({ listasBienesAsegurables, listaTiposConstruccion, tipoConstrucciones }) => {
        this.listaTipoConstruccion          = listaTiposConstruccion;
        this.segurosBienes                  = segurosBienes;
        this.segurosBienesTipoConstrucciones = tipoConstrucciones;
        this.listaBinesAsegurablesTodos     = listasBienesAsegurables;
        this.construirFormularioDinamico();
      });
    }, error => {
      this.navServicio.setMesage( 0, {
        severity: 'error', summary: this.navServicio.buscarMensaje( 'LBL_INFORMACION' ),
        detail: this.navServicio.buscarMensaje( 'SEGURO.MSG_ERRORCARGARBIENESASEGURADOS' )
      } );
      console.error('Error al cargar bienes asegurables:', error);
      this.loading = false;
    });
  }





  private construirFormularioDinamico(
  ): void {

    this.bienesArray.clear();

    this.listaBinesAsegurablesTodos.forEach(param => {
      const seguroBien = this.segurosBienes.find(b => b.idListaBienAsegurable === param.idLista);

      const valorSeleccionado: string[] = [];
      if ( this.segurosBienesTipoConstrucciones &&  this.segurosBienesTipoConstrucciones?.length > 0) {
        this.segurosBienesTipoConstrucciones.forEach(e => {
          if (e.indicadorHabilitado) {
            valorSeleccionado.push(e.idListaTipoConstruccionVivienda);
          }
        });
      }

      const tipoParametro = this.parametrosTipoLista.includes(param.codigo) ? 'SELECT' : 'LABEL';

      const grupoFila = this.fb.group({
        idListaBienAsegurable: new FormControl(param.idLista),
        idSeguro: new FormControl(this.seguro.idSeguro),
        idSeguroBien: new FormControl(seguroBien ? seguroBien.idSeguroBien  : null),
        codigo:                new FormControl(param.codigo),
        descripcion:           new FormControl(param.nombre),
        tipoParametro:         new FormControl(tipoParametro),
        indicadorObligatorio:  new FormControl(
          {
            value:    seguroBien?.indicadorObligatorio ?? false,
            disabled: !(seguroBien?.indicadorHabilitado ?? false)
          }
        ),
        indicadorHabilitado:   new FormControl(seguroBien ? seguroBien.indicadorHabilitado   : false),

        opciones:              new FormControl(
          tipoParametro === 'SELECT'
            ? this.listaTipoConstruccion.map(t => ({ label: t.nombre, value: t.idLista }))
            : []
        ),
        valorSeleccionado: new FormControl(
          valorSeleccionado.length > 0 ? valorSeleccionado : [],
          tipoParametro === 'SELECT' && (seguroBien?.indicadorHabilitado ?? false)
            ? this.validarSeleccionRequerida()
            : []
        )
      });


      this.bienesArray.push(grupoFila);



    });
    this.loading = false;
  }

  onToggleHabilitado(event: any, control: AbstractControl): void {
    const habilitado = event.checked;
    const controlObligatorio = control.get('indicadorObligatorio');

    if (!habilitado) {
      controlObligatorio?.setValue(false);
    }

    if (control.get('tipoParametro')?.value === 'SELECT') {
      const controlValor = control.get('valorSeleccionado');
      if (habilitado) {
        controlValor?.setValidators(this.validarSeleccionRequerida());
      } else {
        controlValor?.clearValidators();
        controlValor?.setValue([]);
      }
      controlValor?.updateValueAndValidity();
    }
  }

  private validarSeleccionRequerida(): ValidatorFn {
    return (control: AbstractControl) => {
      const valor = control.value;
      return !valor || valor.length === 0 ? { seleccionRequerida: true } : null;
    };
  }

  onSubmit(): void {
    this.submitted = true;

    if (this.formulario.invalid) {
      return;
    }

    this.loading = true;

    const datosAPersistir  = this.bienesArray.getRawValue().map((item: any) => ({
      idSeguro:              this.seguro.idSeguro,
      idListaBienAsegurable: item.idListaBienAsegurable,
      idSeguroBien:          item.idSeguroBien ?? null,
      codigo:                item.codigo,
      indicadorObligatorio:  item.indicadorObligatorio,
      indicadorHabilitado:   item.indicadorHabilitado
    }));

    this.segurosbienesService.bulk(datosAPersistir).subscribe({
      next: (response: SegurosBienes[]) => {
        const itemBietic = this.bienesArray.value.find(
          (item: any) => item.codigo === ParametrosSegurosBienes.BIETIC
        );

        const seguroBienGuardado = response?.find(
          (r: SegurosBienes) => r.idListaBienAsegurable === itemBietic?.idListaBienAsegurable
        );

        if (!itemBietic || !seguroBienGuardado) {
          this.finalizarGuardado(1);
          return;
        }

        const idsSeleccionados: string[] = itemBietic.valorSeleccionado ?? [];

        const tiposGuardadosPrevios = this.segurosBienesTipoConstrucciones.filter(
          t => t.idSeguroBien === seguroBienGuardado.idSeguroBien
        );

        const listSegurosTipoConstruccion: Partial<SegurosBienesTipoConstruccion>[] = [];


        idsSeleccionados.forEach((idLista: string) => {
          const existente = tiposGuardadosPrevios.find(
            t => t.idListaTipoConstruccionVivienda === idLista
          );
          listSegurosTipoConstruccion.push({
            idSeguroBienTipoConstruccion:    existente?.idSeguroBienTipoConstruccion ?? null,
            idListaTipoConstruccionVivienda: idLista,
            idSeguroBien:                   seguroBienGuardado.idSeguroBien,
            indicadorHabilitado:            true
          });
        });

        tiposGuardadosPrevios
          .filter(t =>
            t.indicadorHabilitado &&
            !idsSeleccionados.includes(t.idListaTipoConstruccionVivienda)
          )
          .forEach(t => {
            listSegurosTipoConstruccion.push({
              idSeguroBienTipoConstruccion:    t.idSeguroBienTipoConstruccion,
              idListaTipoConstruccionVivienda: t.idListaTipoConstruccionVivienda,
              idSeguroBien:                   seguroBienGuardado.idSeguroBien,
              indicadorHabilitado:            false
            });
          });

        if (!listSegurosTipoConstruccion.length) {
          this.finalizarGuardado(this.tieneSegurosBienes() ? 2 : 1);
          return;
        }

        this.segurosBienesTipoConstruccionService.bulk(
          listSegurosTipoConstruccion as SegurosBienesTipoConstruccion[]
        ).subscribe({
          next: (response) => {
            this.finalizarGuardado(this.tieneSegurosBienes() ? 2 : 1);
          },

          error: (err) =>  {
            this.manejarErrorGuardado('SEGURO.MSG_ERRORGUARDARBIENESTIPOSCONSTRUCCION', err);
          }
        });
      },
      error: (err) => {
        this.manejarErrorGuardado('SEGURO.MSG_ERRORGUARDARBIENESASEGURADOS', err);
      }
    });
  }

  /** Indica si segurosBienes es un arreglo con al menos un elemento. */
  private tieneSegurosBienes(): boolean {
    return Array.isArray(this.segurosBienes) && this.segurosBienes.length > 0;
  }

  /** Éxito: baja la bandera vía recarga y notifica guardado/actualizado. */
  private finalizarGuardado(codigoMensaje: number): void {
    this.submitted = false;
    this.cargarDatos();
    this.navServicio.setMesage(codigoMensaje);
  }

  /** Baja la bandera de carga y muestra el mensaje de error indicado. */
  private manejarErrorGuardado(detalle: string, err: any): void {
    this.submitted = false;
    this.loading = false;
    console.error(err);
    this.navServicio.setMesage(0, {
      severity: 'error',
      summary: this.navServicio.buscarMensaje('LBL_INFORMACION'),
      detail: this.navServicio.buscarMensaje(detalle)
    });
  }

  onCancelar(): void {
    this.cancelar.emit();
  }


}
